export default __webpack_public_path__ + "static/media/IMAGE_1674359387.79fd229b.jpg";